import { render } from "./iconfont.vue?vue&type=template&id=ff817ad8"
import script from "./iconfont.vue?vue&type=script&lang=js"
export * from "./iconfont.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\idbrand\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__